export default function SvgMinus(props) {
  return (
    <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.25 1C13.25 1.19891 13.171 1.38968 13.0303 1.53033C12.8897 1.67098 12.6989 1.75 12.5 1.75H1.5C1.30109 1.75 1.11032 1.67098 0.96967 1.53033C0.829018 1.38968 0.75 1.19891 0.75 1C0.75 0.801088 0.829018 0.610322 0.96967 0.46967C1.11032 0.329018 1.30109 0.25 1.5 0.25H12.5C12.6989 0.25 12.8897 0.329018 13.0303 0.46967C13.171 0.610322 13.25 0.801088 13.25 1Z" fill="currentColor" />
    </svg>
  )
}
